"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Association = void 0;
const index_1 = require("../Base/index");
/**
 * Contains a BPMN Association.
 * These associations are used to link FlowNode elements with annotations,
 * such as TextAnnotations.
 */
class Association extends index_1.BaseElement {
}
exports.Association = Association;
//# sourceMappingURL=Association.js.map